export default [
    {
        path: 'relatorio-rastreio-ferida',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-rastreio-ferida' */
            '@/views/ambulatorio/relatorio-rastreio-ferida/Index'
        ),
        redirect: 'relatorio-rastreio-ferida/index',
        children: [
            {
                name: 'ambulatorio-relatorio-rastreio-ferida-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-rastreio-ferida' */
                    '@/views/ambulatorio/relatorio-rastreio-ferida/List.vue'
                ),
            },
        ],
    },
]